<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <!-- App Starts here -->
    <!-- Content Loaded Under Vue Content based on Routing-->
    <!-- App Header is Placed for All Pages -->
    <v-main>
      <app-header v-if="showNav" />
      <Alert />
      <v-dialog content-class="modal-popup" persistent v-model="timeOutModel">
        <v-card rounded="rounded-xl" raised outlined class="center containerbox overflow-x-hidden">
          <v-card-title>
            <v-row>
              <v-col sm="12" md="12" lg="12"> Still with us? </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="12" md="12" lg="12" class="pa-10 pb-10">
                Your session will expire in <span class="font-weight-semibold inactiveColor--text">
                  {{ timerCounter }} (s)
                </span> due to inactivity. Click Continue to extend your session
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col sm="12" md="12" lg="12" class="pa-0 ma-0 pt-5 text-right">
                <v-btn class="btn-style ma-2" outlined color="primarytext" elevation="1" @click="continueSession">
                  Continue
                </v-btn>
                <v-btn class="btn-style ma-2 pl-2" outlined color="secondary" elevation="1" @click="logoutSession">
                  Logout
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <router-view class="pt-10" :key="$route.fullPath"></router-view>
    </v-main>
    <!-- Fixed Footer for all Pages -->
    <AnnouncementDisplay v-if="showNav" />
    <v-footer class="pa-2 pt-3" :style="{ background: $vuetify.theme.themes[theme].background }">
      <v-col class="text-center pa-2" md="12" sm="12" lg="12" id="footer">
        &copy;{{ new Date().getFullYear() }} — Powered by
        <strong>Industrialytics </strong>
      </v-col>
    </v-footer>
    <LoaderDialog />
  </v-app>
</template>
<script>
import Header from "./components/header/header";
import LoaderDialog from "./components/common/loader-dialog";
import Alert from "./components/common/alert";
import BrowserUtility from "./components/utility/js/browser-utility"
import {
  INACTIVE_USER_TIME_THRESHOLD,
  APPCODE
} from "./components/utility/js/constants-utility";
import EncryptUtility from "./components/utility/js/encrypt-utility.js";
import Utility from "./shared/utility";
import { mapState } from 'vuex';
import jwt_decode from 'jwt-decode';
import authHeader from '../src/services/auth-header';
import AnnouncementDisplay from "./components/common/announcement-display.vue";
const LAST_ACTIVITY_KEY = "lastUserActivity";
export default {
  name: "app",
  data() {
    return {
      localTime: 0,
      expTime: 0,
      currTime: 0,
      appCode: "Web",
      userActivityThrottlerTimeout: null,
      userActivityTimeout: null,
      userActivityRefreshTokenTimeout: null,
      timeOutModel: false,
      timerCounter: 0, //set the idle timer counter 
      userIdle: false, //set if user is idle or not
      localKey: [],
      keyValues: [],
      key: '',
      expiredTime: 0,
      currentTime: 0,
      warningTime: 0,
      minutes: 0,
      intervalId: null,
      timeExpiry: 0,
      timeCurrent: 0,
    }
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    prevRoutePath() {
      return EncryptUtility.localStorageDecrypt('LastRoute') === undefined ? null : JSON.parse(EncryptUtility.localStorageDecrypt('LastRoute'));
    },
    presentRoutePath() {
      return EncryptUtility.localStorageDecrypt('PresentRoute') === undefined ? null : JSON.parse(EncryptUtility.localStorageDecrypt('PresentRoute'));
    },
    ...mapState({
      showNav: state => state.ConfigModule.showNav
    }),

  },
  components: {
    "app-header": Header,
    LoaderDialog,
    Alert,
    AnnouncementDisplay,
  },
  created() { },
  mounted() {
    localStorage.setItem(LAST_ACTIVITY_KEY, Date.now());
    this.removeLocalStorage();
    this.localTime = EncryptUtility.localStorageDecrypt('JWTExp');
    this.expTime = this.localTime == undefined ? 0 : this.localTime * 1000;
    this.currTime = new Date().getTime();
    if (this.expTime > this.currTime) {
      this.showNav = true
    }
    else {
      this.showNav = false;
      localStorage.clear();
    }
    //Browser Details
    BrowserUtility.osName();
    BrowserUtility.browserDetails();
    // Get Environment Details
    let elHtml = document.getElementsByTagName("html")[0];
    elHtml.style.overflowY = "auto";
    if (this.$route.path !== '/login') {
      this.activateActivityTracker();
      this.resetUserActivityTimeout();
    }
    this.userActivityRefreshToken();  // Run immediately
    // Set up the interval to call the function every 2 min
    this.intervalId = setInterval(this.userActivityRefreshToken, 120000);
    if (this.$route.path !== '/login') {
      window.addEventListener("storage", this.handleStorageEvent);
      window.addEventListener("storage", this.syncActivityAcrossTabs);
    }
  },
  methods: {
    //User activity checker for session timeout
    //Activating trackers for the page
    activateActivityTracker() {
      window.addEventListener("mousemove", this.userActivityThrottler);
      window.addEventListener("scroll", this.userActivityThrottler);
      window.addEventListener("keydown", this.userActivityThrottler);
      // window.addEventListener("resize", this.userActivityThrottler);
    },
    //Deactivating trackers for the page
    deactivateActivityTracker() {
      window.removeEventListener("mousemove", this.userActivityThrottler);
      window.removeEventListener("scroll", this.userActivityThrottler);
      window.removeEventListener("keydown", this.userActivityThrottler);
      // window.removeEventListener("resize", this.userActivityThrottler);
    },
    //Checking users activity every seconds if no activity calls the timeout
    userActivityThrottler() {
      if (this.userIdle || this.$route.path === '/login') return;
      localStorage.setItem(LAST_ACTIVITY_KEY, Date.now());
      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
      }
      this.resetUserActivityTimeout();
    },
    //Reset the user activity or timeout 
    resetUserActivityTimeout() {
      clearTimeout(this.userActivityTimeout);
      this.userActivityTimeout = setTimeout(() => {
        const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || 0);
        const diff = Date.now() - lastActivity;
        if (diff >= INACTIVE_USER_TIME_THRESHOLD) {
          this.inactiveUserAction();
        } else {
          this.resetUserActivityTimeout();
        }
      }, INACTIVE_USER_TIME_THRESHOLD);
    },
    inactiveUserAction() {
      if (this.timeOutModel || this.$route.path === '/login') return;
      const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || 0);
      const diff = Date.now() - lastActivity;
      if (diff < INACTIVE_USER_TIME_THRESHOLD) {
        this.resetUserActivityTimeout();
        return;
      }
      localStorage.setItem("showIdlePopup", Date.now());
      this.userIdle = true;
      this.timeOutModel = true;
      this.timerCounter = 120;
      this.deactivateActivityTracker();
      clearInterval(this.warningInterval);
      this.warningInterval = setInterval(() => {
        if (this.timerCounter > 0) {
          this.timerCounter--;
        } else {
          clearInterval(this.warningInterval);
          this.logoutSession();
        }
      }, 1000);
    },
    continueSession() {
      localStorage.setItem(LAST_ACTIVITY_KEY, Date.now());
      this.timeOutModel = false;
      this.userIdle = false;
      clearInterval(this.warningInterval);
      this.activateActivityTracker();
      this.resetUserActivityTimeout();
      this.userActivityRefreshToken();
    },
    userActivityRefreshToken() {
      this.localTime = EncryptUtility.localStorageDecrypt('JWTExp');
      if (this.localTime !== undefined) {
        this.expTime = this.localTime == undefined ? 0 : this.localTime * 1000;
        this.timeExpiry = this.formatDate(this.expTime);
        this.currTime = new Date().getTime(); // current time
        this.timeCurrent = this.formatDate(this.currTime);
        this.minutes = this.calculateMinutes(this.timeExpiry, this.timeCurrent);
        console.log("CD ", this.timeCurrent, "ED ", this.timeExpiry, "MD ", this.minutes);
        if (this.minutes <= 8) {
          this.refreshToken()
        } else if (this.minutes == 0 || this.minutes == null || this.minutes == undefined) {
          Utility.logOut();
        }
      }
    },
    formatDate(epoch) {
      const date = new Date(epoch);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    calculateMinutes(timeExpiry, timeCurrent) {
      let time1 = new Date(timeExpiry);
      let time2 = new Date(timeCurrent)
      const diffInMilliseconds = time1.getTime() - time2.getTime();
      const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
      const minutes = Math.floor(diffInSeconds / 60);
      return minutes;
    },
    //Logout button click event
    logoutSession() {
      clearInterval(this.warningInterval);
      this.$vuetify.theme.dark = false;
      Utility.logOut();
    },
    //Refresh token for authorization
    refreshToken() {
      let loginModel = {
        UserId: EncryptUtility.localStorageDecrypt('userID'),
        AppCode: APPCODE,
        Token: EncryptUtility.localStorageDecrypt('Token'),
      }
      this.axios
        .post("ap/refresh_token", loginModel)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responseData = response.data.body;
            EncryptUtility.localStorageEncrypt('Token', responseData.Jwt);
            this.decoded = jwt_decode(responseData.Jwt);
            EncryptUtility.localStorageEncrypt(
              'JWTExp',
              JSON.stringify(this.decoded.exp),
            );
            this.localTime = EncryptUtility.localStorageDecrypt('JWTExp')
            authHeader(responseData.Jwt);
          }
          else {
            //show error
            this.logoutSession(); //force logout
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          this.logoutSession(); //force logout
        });
    },
    //Page level localstorage items clearing
    removeLocalStorage() {
      if (this.prevRoutePath === null)
        return "";
      if (this.presentRoutePath === null)
        return "";
      this.localPrevKey = this.prevRoutePath.slice(1).split("-");
      this.localPresentKey = this.presentRoutePath.slice(1).split("-");
      if (this.localPrevKey.length >= 2) {
        this.keyPrv = this.localPrevKey[0].substring(0, 1).toUpperCase() + this.localPrevKey[1].substring(0, 1).toUpperCase();
      } else {
        this.keyPrv = this.localPrevKey[0].substring(0, 1).toUpperCase();
      }
      if (this.localPresentKey.length >= 2) {
        this.keyPrs = this.localPresentKey[0].substring(0, 1).toUpperCase() + this.localPresentKey[1].substring(0, 1).toUpperCase();
      } else {
        this.keyPrs = this.localPresentKey[0].substring(0, 1).toUpperCase();
      }
      this.keyValues = this.allStorage();
      if (this.keyPrs !== this.keyPrv) {
        for (var key = 0; key < this.allStorage().length; key++) {
          if (this.keyValues[key].substring(0, 2) == this.keyPrv) {
            EncryptUtility.localStorageRemoveItem(this.keyValues[key]);
          }
        }
      }
    },
    allStorage() {
      var values = [],
        keys = Object.keys(localStorage),
        i = keys.length;
      while (i--) {
        values.push(EncryptUtility.localStorageDecryptKey(keys[i]));
      }
      return values;
    },
    handleStorageEvent(event) {
      if (event.key === null) {
        console.log("Logout detected in another tab");
        setTimeout(() => {
          if (this.$route.path !== "/login") {
            Utility.logOut();
          }
        }, 1000);
      }
    },
    syncActivityAcrossTabs(event) {
      if (event.key === LAST_ACTIVITY_KEY) {
        clearTimeout(this.userActivityTimeout);
        this.resetUserActivityTimeout();
        if (this.timeOutModel) {
          this.timeOutModel = false;
          this.userIdle = false;
          clearInterval(this.warningInterval);
        }
      }
      if (event.key === "showIdlePopup" && !this.timeOutModel) {
        this.inactiveUserAction();
      }
    },
  },
  beforeDestroy() {
    this.deactivateActivityTracker();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (this.userActivityTimeout) {
      clearTimeout(this.userActivityTimeout);
    }
    if (this.userActivityThrottlerTimeout) {
      clearTimeout(this.userActivityThrottlerTimeout);
    }
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.handleStorageEvent);
    window.removeEventListener("storage", this.syncActivityAcrossTabs);
  },
  destroyed: function () {
    let elHtml = document.getElementsByTagName("html")[0];
    elHtml.style.overflowY = null;
  },
};
</script>
<style scoped>
@import "./assets/styles/common.css";
</style>
